var styles = {"dot":"LoadingDots-module_dot__S6ACt","bounce":"LoadingDots-module_bounce__uLYgI"};

export { styles as default };
